/**
 * KAN-875: стрелки по краям горизонтальной строки. Видны только на устройствах
 * с мышью (media hover: hover и pointer: fine) и только в сторону, куда есть
 * прокрутка. Родитель строки должен быть relative.
 */
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ScrollDirection } from '@/hooks/useHorizontalScroll';

interface ScrollArrowsProps {
  canScrollLeft: boolean;
  canScrollRight: boolean;
  onScroll: (direction: ScrollDirection) => void;
}

const ARROW =
  'absolute top-1/2 z-10 hidden h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-gray-600 shadow ring-1 ring-gray-200 hover:text-gray-900 [@media(hover:hover)_and_(pointer:fine)]:flex';

export function ScrollArrows({ canScrollLeft, canScrollRight, onScroll }: ScrollArrowsProps): JSX.Element {
  return (
    <>
      {canScrollLeft && (
        <button
          type="button"
          aria-label="Прокрутить влево"
          className={cn(ARROW, 'left-1')}
          onClick={() => onScroll('left')}
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
      )}
      {canScrollRight && (
        <button
          type="button"
          aria-label="Прокрутить вправо"
          className={cn(ARROW, 'right-1')}
          onClick={() => onScroll('right')}
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      )}
    </>
  );
}
